import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";


@Injectable({ providedIn: 'root' })
export class PortalBeHttpClient {
 
    constructor(private http: HttpClient) { }

    post(url: string, body: any, headers?: any) {
        return this.http.post(this.getBaseApiUrl() + url, body, { headers: headers, observe: 'response' });
    }

    get(url: string, urlParams?: { params: any; } | null, responseType?: any, headers?: any, includeResponseHeaders: boolean = false) {
        const fullUrl = this.getBaseApiUrl() + url;

        const options: any = {};
        if(urlParams && urlParams.params) {
            options['params'] = new HttpParams().appendAll(urlParams.params);
        }

        if(responseType) {
            options['responseType'] = responseType;
        }

        if(headers) {
            options['headers'] = headers;
        }

        if(includeResponseHeaders) {
            options['observe'] = 'response';
        }

        return this.http.get(fullUrl, options);
    }

    put(url: string, body: any) {
        return this.http.put(this.getBaseApiUrl() + url, body);
    }

    getBaseApiUrl(): string {
        return environment.portalConfig.legacyPortalAPIBasePath;
    }
}